import { createPortal } from "react-dom";
import type { Bestellgruppe } from "../../api/bestellgruppen.ts";
import type { Order, SendungsTreffer } from "../../lib/types.ts";
import { BestellgruppenBereich } from "./BestellgruppenBereich.tsx";
import { DsvGruppenVergleich } from "./DsvGruppenVergleich.tsx";
import { hatRecht } from "../Drawer/drawerRechte.ts";

export interface BestellgruppenAnsichtProps {
  gruppe: Bestellgruppe;
  bestellungen: readonly Order[];
  rechte: ReadonlySet<string>;
  onSchliessen: () => void;
  onBestellungOeffnen?: (orderId: string) => void;
  onMitgliedHinzufuegen?: (orderId: string) => void;
  onMitgliedLoesen?: (orderId: string) => void;
  onGruppeAufloesen?: (retainedOrderIds: string[]) => void;
  sendungsSuche?: (begriff: string) => Promise<SendungsTreffer[]>;
  onGruppenSendungSetzen?: (shipmentId: string) => void | Promise<void>;
}

export function BestellgruppenAnsicht({ gruppe, bestellungen, rechte, onSchliessen, ...bereich }: BestellgruppenAnsichtProps) {
  const anker = bestellungen.find((bestellung) => gruppe.members.some((mitglied) => String(bestellung.id) === mitglied.orderId))
    ?? { id: gruppe.members[0]?.orderId ?? gruppe.id } as Order;
  return createPortal(
    <div className="board-editor-overlay open" role="presentation" onClick={(ereignis) => { if (ereignis.target === ereignis.currentTarget) onSchliessen(); }}>
      <section className="board-editor-dialog bestellgruppen-ansicht" role="dialog" aria-modal="true" aria-labelledby="bestellgruppenAnsichtTitel">
        <div className="board-editor-head"><h2 id="bestellgruppenAnsichtTitel">Bestellgruppe</h2></div>
        <div className="board-editor-body">
          <BestellgruppenBereich
            bestellung={anker}
            bestellungen={bestellungen}
            gruppe={gruppe}
            gruppenansicht
            darfBearbeiten={hatRecht(rechte, "edit_orders")}
            {...bereich}
          />
          {gruppe.status === "active" && hatRecht(rechte, "edit_orders") && bereich.onGruppenSendungSetzen ? (
            <DsvGruppenVergleich
              gruppe={gruppe}
              bestellungen={bestellungen}
              sendungsSuche={bereich.sendungsSuche}
              onBestaetigen={bereich.onGruppenSendungSetzen}
            />
          ) : null}
        </div>
        <div className="board-editor-foot"><button type="button" className="btn-sec" onClick={onSchliessen}>Schließen</button></div>
      </section>
    </div>,
    document.body,
  );
}
